import Vue from 'vue'

// initial state
const state = {
  userStatistics: {
    users: []
  }
}

// getters
const getters = {
  users: state => state.userStatistics.users
}

// mutations
const mutations = {
  setUserStatistics (state, userStatistics) {
    userStatistics.forEach(user => {
      user.lastActiveAt = user.lastActiveAt.split('T')[0]
      user.firstLoginAt = user.firstLoginAt.split('T')[0]
      user.blocks = []
      user.typeOfNotifications = []
      if (user.hasSms) user.typeOfNotifications.push('SMS')
      if (user.hasMail) user.typeOfNotifications.push('E-Mail')
      if (!user.hasMail && !user.hasSms) user.typeOfNotifications.push('Webbnotis')
      user.realEstates.forEach(re => {
        if (!user.blocks.includes(re.block)) {
          user.blocks.push(re.block)
          delete re.block
        }
      })
    })
    state.userStatistics.users = userStatistics
  }
}

// actions
const actions = {
  async fetchUserStatistics ({ commit }) {
    const res = await Vue.axios.get('/api/statistics/accounts/')
    if (res.status === 200) commit('setUserStatistics', res.data.accountStats)
  },

  async deleteAccount ({ commit, dispatch }, val) {
    const res = await Vue.axios.delete(`/api/accounts/${val.username}`)
    if (res.status === 200) {
      await dispatch('fetchUserStatistics')
      return true
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/statistics.js